export function mask(type, value) {
    switch (type) {
        case 'cep': {
            return '99999-999';
        }
        case 'phone': {
            if (Phone(value || "").unmask?.length === 11)
                return '99 99999-999?';
            return '99 9999-999??';
        }
        case 'cpf': {
            return '999.999.999-99';
        }
        case 'cnpj': {
            return '99.999.999/9999-99';
        }
        case 'ie': {
            return '99999999999999';
        }
        case 'cpfCnpj': {
            if (Number(value?.length) <= 14)
                return '999.999.999-99';
            return '99.999.999/9999-99';
        }
        default:
            return '';
    }
}
export function formatChars(type) {
    switch (type) {
        case 'phone': {
            return { 9: '[0-9]', '?': '[0-9]' };
        }
        default:
            return null;
    }
}
export const getInputPaddingBySize = (size) => {
    const paddingValues = {
        small: '3px',
        default: '7px',
        large: '11px',
    };
    return paddingValues[size ?? 'default'];
};
//# sourceMappingURL=helpers.js.map